import { OSSDataConfig } from './interface';

export function getExtraData(file: any, OSSData?: OSSDataConfig) {
  return {
    key: (file.relativePath as string).substr(1),
    OSSAccessKeyId: OSSData?.accessid,
    policy: OSSData?.policy,
    Signature: OSSData?.signature,
    success_action_status: 200,
  };
}

export const getFileList = function(
  fileList: any[] = [],
  file: any,
  otherParams: any,
): any[] {
  const currentFile = {
    uid: file.uid,
    type: file.type,
    size: file.size,
    name: file.name,
  };
  const findItem = fileList.find(v => v.uid === file.uid);
  if (findItem) {
    return fileList.map(v => {
      if (v.uid === file.uid) {
        return { ...v, ...otherParams };
      }
      return v;
    });
  }
  return [...fileList, { ...currentFile, ...otherParams }];
};
